import { FilterOption } from "../../shared/constants/filter.constants";

export class QuestionFilterDataModel {
  public id: number;
  public answerType: string;
  public listAnswerId: number[];
  public operator: string;
  public input: string;
  public isOrOpr: boolean;
}

export class SurveyVersionModelCore {
  public surveyName: string;
  public hash: string;
  public isSelected: boolean;
  public missingQuestionIds: number[];

  constructor() {
      this.isSelected = false;
  }
}

export class SurveyCutModelCore {
  public title: string;
  public id: number;
  public createBy: boolean;
  public isSelected: boolean;
  public missingQuestionIds: number[];
}

export class SurveyCutsModel {
  public id: number;
  public listCut: SurveyCutModelCore[];
  public title: string;
}

export class IncludeSurveyModel {
  public listSurveyVersion: SurveyVersionModelCore[];
  public listSurveyCut: SurveyCutModelCore[];
  public allResponsesSelected: boolean;
  public allVersionSelected: boolean;
  public compare: boolean;

  constructor() {
      this.listSurveyVersion = [];
      this.listSurveyCut = [];
  }
}

export class SummaryFilterModel {
  public includeSurvey: IncludeSurveyModel;
  public listQuestionFilter: QuestionFilterDataModel[];
  public hash: string;
  public version: string;
  public IdSurvey: number;
  public isOrOperator: string;

  constructor(includeSurvey: IncludeSurveyModel,
              listQuestionFilter: QuestionFilterDataModel[],
              hash: string = null, 
              version: string = null,
              idSurvey: number = null,
              isOrOperator: string = FilterOption.AND) {
    this.includeSurvey = includeSurvey;
    this.listQuestionFilter = listQuestionFilter;
    this.hash = hash;
    this.version = version;
    this.IdSurvey = idSurvey;
    this.isOrOperator = isOrOperator;
  }
}

export class SurveyLanguageModelCore {
  public languageId: number;
  public language: string;
  public isSelected: boolean;
  public isCurrent: boolean;
}


// WEBPACK FOOTER //
// ./src/app/models/summary/summary.model.ts